import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../../../models/ui/User';
import { AuthService } from '../../services';
import { LookupService } from 'src/app/services/Lookup/lookup.service';
import { error } from 'util';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})
export class LoginFormComponent implements OnInit {
  ngOnInit() {

  }
  
  loadingVisible = false;

  logCount = 0;

  userDetails: User;
  loggedUser: User;
  userRole: string;
  currentUserRole: string;
  authenticationResponse: string;

  constructor(private router: Router, private authService: AuthService, private lookupService: LookupService,private _jwtHelper: JwtHelperService) {
      this.userDetails = new User();
      this.loggedUser = new User();
  }

  login(args) {
    this.logCount += 1;
    this.userDetails.LogCount = this.logCount;

    this.loggedUser.UserName = this.userDetails.UserName;
    this.loggedUser.Password = this.userDetails.Password;
    
    if (!args.validationGroup.validate().isValid) 
    {
      return;
    } 
    else
    {
      this.loadingVisible = true;
      this.authService.checkUserDetails(this.userDetails)
      .subscribe(
        data => this.processLogin(data, this.loggedUser), // Pass both data and this.loggedUser as arguments
        error => {
          setTimeout(() => {
            this.loadingVisible = false;
            if (error.message.includes("Not Found"))
              alert("Unknown username or password");
            else
              alert("An error has occurred. If your account is locked, please reset your password to unlock it or contact support to resolve the issue.");
          }, 1000 * this.logCount);
        }
      );
    }

    args.validationGroup.reset();
  }

  processLogin(authenticationResponse, user) {

    localStorage.setItem("ProviderCurrentUsername", user.UserName);
      
      if(authenticationResponse.includes("YOUR PASSWORD WILL EXPIRE")
      || authenticationResponse.includes("EXPIRED")) {
        localStorage.setItem("isExpiring", "true");
        alert(authenticationResponse);
        setTimeout(() => {
          location.assign("#/change-password");
        }, 1000);
      } else if (authenticationResponse.includes("THE USERNAME OR PASSWORD IS INCORRECT")){ 
        alert(authenticationResponse);
      } else { 
          const token = authenticationResponse;
          const tokenDetails = this._jwtHelper.decodeToken(authenticationResponse);
          localStorage.setItem("ProviderToken", token); 
          localStorage.setItem("currentSessionTokenKey", tokenDetails.sessionTokenKey); 
          localStorage.setItem("loggedUsername", user.UserName);
          this.lookupService.getClemittanceToken(user).subscribe(data=> this.fetchRole(user, data));
          this.fetchRole(user, "");
      }
  }

  fetchRole(user, data) {
    localStorage.setItem("clemittanceTokenKey", data);
    this.currentUserRole = localStorage.getItem("UserRole");
    this.lookupService.getUserRole(user).subscribe(data => this.processRole(data));
  }

  processRole(role) {
    if(role == "Change password") {
      alert("Please change your password.");
      setTimeout(() => {
        localStorage.setItem("isAuthorized", "true");
        location.assign("#/change-password");
      }, 1000);
    }
    else{
      if(this.currentUserRole != role)
      {
        localStorage.setItem("UserRole", role);
        localStorage.setItem("reloadPage", "true");
      }
      localStorage.setItem("isAuthorized", "true");
      this.loadingVisible = false;
      location.assign("#/home");
    }
  }
}